<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;">
        <v-layout class="row wrap">
            <v-flex class="xs12" >
                <span style="font-weight: bold; font-size: 17px;">정기차량 관리 - 전체 주차장 현황</span>
            </v-flex>
        </v-layout>

        <v-container
                fluid
                class="pa-2 grid-list-lg"
                v-for="item in list"
                :key="item.yearmonth">
            <v-layout
                    class="row wrap justify-center "
                    style="font-size: 30px; font-weight: bold; ">
                {{ item.yearmonthname }}
            </v-layout>
            <v-layout
                    class="row wrap justify-center "
                    style="font-size: 20px; font-weight: normal;">
                ￦ {{ tool_app.numberWithCommas(item.pay) }}.&nbsp;&nbsp;
                {{ item.curcarcount }} / {{ item.carcount }} ({{ Math.round(item.curcarcount / item.carcount * 1000) / 10 }}%)
            </v-layout>
            <v-layout
                    class="row wrap"
                    style="margin-bottom: 20px;"
            >
                <v-flex class="xs12 sm6 md3 lg2 xl2"
                        v-for="item in item.parkinglots"
                        :key="item.ParkingLotIDX"
                >
                    <v-btn class="pa-1 card" style="width: 100%;" v-bind:class="[(item.curcarcount / item.carcount >= 0.9)?'blue':((item.curcarcount / item.carcount >= 0.6)?'yellow':'red')]"
                           @click="$router.push({path: '/periodiccarmanage/'+item.ParkingLotIDX});">
                        <table style="width: 100%; table-layout: fixed; font-weight: bold; font-size: 15px; height: 100px;">
                            <tr>
                                <td style="vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                    {{item.Name}}
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                    {{ item.curcarcount }} / {{ item.carcount }} ({{ Math.round(item.curcarcount / item.carcount * 1000) / 10 }}%)
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                                                                    {{tool_app.numberWithCommas(item.PaymentAmount - item.RefundAmount)}}원
                                </td>
                            </tr>
                            <tr>
                                <td style="vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">
                                                                                    대기차량: {{item.StandByCarCount}}대
                                </td>
                            </tr>
                        </table>
<!--                        <span style="width: 100%; vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">-->
<!--                            {{item.Name}} ㅁ다비다 ㅂㅈㄷqwekqlwke ㅂㅈ디ㅏㅂㅈㄷ받-->
<!--                        </span>-->
<!--                        <span style="width: 100%; vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden;">-->
<!--                                                {{ item.curcarcount }} / {{ item.carcount }} ({{ Math.round(item.curcarcount / item.carcount * 1000) / 10 }}%)-->
<!--                        </span>-->
<!--                        <span style="width: 100%; vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden;">-->
<!--                                                {{tool_app.numberWithCommas(item.PaymentAmount - item.RefundAmount)}}원-->
<!--                        </span>-->
<!--                        <span style="width: 100%; vertical-align: center; text-align: center; color: black; max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden;">-->
<!--                                                대기차량: {{item.StandByCarCount}}대-->
<!--                        </span>-->

<!--                        <table style="width: 100%; height: 70px;">-->
<!--                            <tr>-->
<!--                                <td style="vertical-align: center; text-align: center; color: black;">-->
<!--                                    <table style="width: 100%; table-layout: fixed;">-->
<!--                                        <tr>-->
<!--                                            <td style="max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">-->
<!--                                                {{item.Name}}</td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <td style="max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">-->
<!--                                                {{ item.curcarcount }} / {{ item.carcount }} ({{ Math.round(item.curcarcount / item.carcount * 1000) / 10 }}%)-->
<!--                                            </td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <td style="max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">-->
<!--                                                {{tool_app.numberWithCommas(item.PaymentAmount - item.RefundAmount)}}원</td>-->
<!--                                        </tr>-->
<!--                                        <tr>-->
<!--                                            <td style="max-lines: 1; text-overflow: ellipsis; white-space: nowrap; display: block; word-wrap: normal; overflow: hidden; ">-->
<!--                                                대기차량: {{item.StandByCarCount}}대</td>-->
<!--                                        </tr>-->
<!--                                    </table>-->
<!--                                </td>-->
<!--                            </tr>-->
<!--                        </table>-->
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>

<!--        <v-btn-->
<!--                color="success"-->
<!--                @click="getList()"-->
<!--        >getList</v-btn>-->

    </v-container>
</template>

<style lang="scss">
    .card .v-btn {
        padding: 0;
        min-width: 0;
        width: 100%;
        height: 100%;
    }
    .card .v-btn__content {
        color: #333333;
    }
</style>

<script>
  import tool_app from '../../utils/tool_app';
  import tool_aws from '../../utils/tool_aws';
  import model from '../../utils/model';
  import async from 'async'

  function lg (...args) { tool_app.lg('PeriodicCar_AllParkingLot] ', ...args); }

  let comp = null;
  export default {
    components: { },
    data () {
      return {
        tool_app: tool_app,
        model: model,

        parkinglots_dialog: false,
        parkinglot_selected: {},
        parkinglots: [],

        items_yearmonth: [],

        search: '',

        ismonth: false,
      }
    },
    computed: {
      list: () => {
        tool_app.lg('list 1 search:'+comp.search);
        if(!comp.search) {
          comp.search = '';
        }
        let ret = [];
        comp.items_yearmonth.forEach((value, index, array) => {
          let it = tool_app.copy(value);
          it.parkinglots = it.parkinglots.filter((value1, index1, array1) => {
            if(value1.Name.indexOf(comp.search) >= 0) {
              return true;
            }

            return false;
          });
          if(it.parkinglots.length > 0) {
            ret.push(it);
          }
        });
        return ret;
      }
    },
    created: async function () {
      lg('created 1');
      comp = this;

      tool_app.api(comp, 'SELECT * FROM T_ParkingLot WHERE IsExist = true',
        [])
        .setShowProgressDialog()
        .send()
        .then(async (value) => {
          lg('created 2 value:', value.data.results);
          let session = await tool_aws.getCurrentSession();
          // lg('getList 3 session:\n'+ JSON.stringify(session));
          if(session.idToken.payload['custom:permission'] === '총괄관리자') {
            comp.parkinglots = value.data.results;

            let pidx = comp.$cookies.get('parkinglotidx');
            lg('created 4 pidx:', pidx);
            let s = false;
            if(tool_app.isNumber(pidx) === false) {
              comp.parkinglots.forEach((value1, index, array) => {
                lg('created 5 pidx:', pidx, ' value1.ParkingLotIDX:', value1.ParkingLotIDX);
                if(value1.ParkingLotIDX === Number(pidx)) {
                  lg('created 6 pidx:', pidx, ' value1.ParkingLotIDX:', value1.ParkingLotIDX);
                  s = true;
                  comp.parkinglot_selected = value1;
                  comp.getList();
                }
              });
            }

            if(s === false) {
              comp.parkinglots_dialog = true;
            }
          }
          else {
            let parkinglots = value.data.results;
            parkinglots.forEach((value1, index, array) => {
              if(value1.ParkingLotIDX === Number(session.idToken.payload['custom:m_parkinglotidx'])) {
                comp.parkinglot_selected = value1;
                // comp.parkinglot_selected_idx = value1.IDX;
                comp.parkinglots = [ comp.parkinglot_selected ];
                comp.getList();
              }
            });
          }
        })
        .catch((reason) => {
          tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
        });
    },
    methods: {
      async getList() {
        lg('getList 1 ');


        /// TODO
        async.parallel([
          function(callback) {
            lg('getList 22 1');

          // count(if(pc.IsStandBy = false, pc.PeriodicCarIDX, null)) as CarCount,
          // count(if(pc.IsStandBy = true, pc.PeriodicCarIDX, null)) as StandByCarCount
            tool_app.api(comp, `
            SELECT count(if(pc.IsStandBy = true, pc.PeriodicCarIDX, null)) as StandByCarCount,
                   p.*
              FROM T_ParkingLot p LEFT OUTER JOIN T_PeriodicCar pc ON
               pc.ParkingLotIDX = p.ParkingLotIDX
                    AND pc.IsExist = true
             WHERE p.IsExist = true
             GROUP BY p.ParkingLotIDX
            `, [])
              .send()
              .then((value) => {
                lg('getList 22 2 value:', value.data.results);
                callback(null, value.data.results);
              })
              .catch((reason) => {
                let err = new Error(JSON.stringify(reason, null, 2));
                tool_app.ex(err);
                callback(err, null);
              });
          },
          function(callback) {
            lg('getList 23 1');

            // -- count(pp.PeriodicCarPaymentIDX) AS PeriodicCarCount,
            tool_app.api(comp, `
    SELECT pp.PaymentYearMonth, pp.PaymentYear, pp.PaymentMonth, p.ParkingLotIDX, p.Name,
           count(if(pp.IsPeriodicCarDeleted = false, pp.PeriodicCarPaymentIDX, null)) AS PeriodicCarCount,
           sum(pp.PaymentAmount) as PaymentAmount, sum(pp.RefundAmount) as RefundAmount
      FROM T_PeriodicCar pc, T_PeriodicCar_Payment pp, T_ParkingLot p
     WHERE p.IsExist = true
       AND pc.IsExist = true
       AND pc.IsStandBy = false
       AND pc.ParkingLotIDX = p.ParkingLotIDX
       AND pp.IsExist = true
       AND pc.PeriodicCarIDX = pp.PeriodicCarIDX
     GROUP BY p.ParkingLotIDX, pp.PaymentYearMonth
     ORDER BY pp.PaymentYearMonth DESC
            `, [])
              .send()
              .then((value) => {
                lg('getList 23 2 value:', value.data.results);
                callback(null, value.data.results);
              })
              .catch((reason) => {
                let err = new Error(JSON.stringify(reason, null, 2));
                tool_app.ex(err);
                callback(err, null);
              });
          },
        ], function(err, results) {
          comp.items_yearmonthday = [];
          lg('getList 91 err:',err,' results:',results);
          // value.data.results.forEach((value1, index, array) => {
          // });
          // optional callback
          if(err) {
            return;
          }
          if(!results || results.length <= 1 || results[0].length <= 0 || results[1].length <= 0) {
            return;
          }

          lg('getList 2 value:', results[1]);
          // let cc = results[0][0].MaxCap;
          let cc = 0;
          results[0].forEach((value, index, array) => {
            cc += value.MaxCap;
          });
          // let cc = comp.parkinglot_selected.MaxCap;
          results[1].forEach((value1, index, array) => {
            let pym = null;
            comp.items_yearmonth.forEach((value2, index1, array1) => {
              if(value2.yearmonth === value1.PaymentYearMonth) {
                pym = value2;
              }
            });
            // comp.periodiccars_yearmonth = [ {
            //   yearmonth: 200810,
            //   yearmonthname: '2008년 10월',
            //   periodiccars: value.data.results
            // }];
            if(pym === null) {
              pym = {
                yearmonth: value1.PaymentYearMonth,
                yearmonthname: value1.PaymentYear + '년 ' + value1.PaymentMonth + '월',
                desc: 'lkjlkj',
                curcarcount: 0,
                carcount: cc,
                pay: 0,
                parkinglots: [],
              }
              comp.items_yearmonth.push(pym);

              results[0].forEach((value3, index2, array2) => {
                let p = tool_app.copy(value3);
                p.ParkingLotIDX = value3.ParkingLotIDX;
                p.PaymentAmount = 0;
                p.RefundAmount = 0;
                p.curcarcount = 0;
                p.carcount = value3.MaxCap;
                p.StandByCarCount = value3.StandByCarCount;
                pym.parkinglots.push(p);
              });
            }

            pym.parkinglots.forEach((value3, index2, array2) => {
              if(value3.ParkingLotIDX === value1.ParkingLotIDX) {
                lg('asd '+value3.ParkingLotIDX+' '+value1.ParkingLotIDX+' '+value1.PaymentAmount+' '+value1.RefundAmount);
                value3.PaymentAmount += value1.PaymentAmount;
                value3.RefundAmount += value1.RefundAmount;
                value3.curcarcount += value1.PeriodicCarCount;
              }
            });
            // lg('getList 3 value1:'+tool_app.showObject(value1));
            pym.curcarcount += value1.PeriodicCarCount;
            // if(value1.IsPeriodicCarDeleted === 0) {
            //   pym.curcarcount++;
            // }
            pym.pay += (value1.PaymentAmount - value1.RefundAmount);
            // pym.parkinglots.push(value1);
          });
        });


        //  tool_app.api(comp, `
        //  SELECT p.*,
        // c.PeriodicCarIDX AS PeriodicCarIDX,c.ParkingLotIDX,c.CarNumber,c.Name,c.Tel,c.Model,c.Description,c.Charge
        //  FROM T_PeriodicCar AS c, T_PeriodicCar_Payment AS p
        // WHERE c.IsExist = true
        //   AND c.IsStandBy = false
        //   AND p.IsExist = true
        //   AND c.PeriodicCarIDX = p.PeriodicCarIDX
        //   AND c.ParkingLotIDX = ?
        // ORDER BY p.PaymentYearMonth DESC, p.PeriodicCarIDX DESC
        // LIMIT 50
        //  `,
        //    [ comp.parkinglot_selected.ParkingLotIDX, ])
        //    .send()
        //    .then((value) => {
        //      // lg('getList 2 value:', value);
        //      // comp.periodiccars = value.data.results;
        //      lg('getList 2 value:', value.data.results);
        //      comp.periodiccars_yearmonth = [];
        //
        //      value.data.results.forEach((value1, index, array) => {
        //        let pym = null;
        //        comp.periodiccars_yearmonth.forEach((value2, index1, array1) => {
        //          if(value2.yearmonth === value1.PaymentYearMonth) {
        //            pym = value2;
        //          }
        //        });
        //        // comp.periodiccars_yearmonth = [ {
        //        //   yearmonth: 200810,
        //        //   yearmonthname: '2008년 10월',
        //        //   periodiccars: value.data.results
        //        // }];
        //        if(pym === null) {
        //          pym = {
        //            yearmonth: value1.PaymentYearMonth,
        //            yearmonthname: value1.PaymentYear + '년 ' + value1.PaymentMonth + '월',
        //            periodiccars: [],
        //          }
        //          comp.periodiccars_yearmonth.push(pym);
        //        }
        //        pym.periodiccars.push(value1);
        //      });
        //    })
        //    .catch((reason) => {
        //      tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
        //    });

      },
    }
  }
</script>
